// extracted by mini-css-extract-plugin
export default {"refinement":"_2WeosbA","input":"Fz4yZ_w","label":"_1ikeRVG"};